<script>
  import { onMount, afterUpdate } from 'svelte';
  import ContainerCarousel from '../layout/containercarousel.svelte';
  export let idUnico;
  export let content;
  let root;

  let elements = [];
  let grupos;
  let grupo = [];

  let comandoBegin;
  let comandoEnd;
  let comandoFrase = '';
  let comandoFraseDesk = '';
  let comandoFraseMob = '';

  onMount(() => {
    comandoBegin = content.search('<comando>');
    if (comandoBegin != -1) {
      comandoEnd = content.search('</comando>');
      if (comandoEnd != -1) {
        comandoFrase = content.substring(comandoBegin + 9, comandoEnd);
        content = content.substring(comandoEnd + 10, content.length);
        comandoFraseDesk = comandoFrase.split(';;')[0];
        comandoFraseMob = comandoFrase.split(';;')[1];
      }
    }

    content = content.replace('craving', '<i>craving</i>');

    grupos = content.split(';;');

    grupos.forEach((element, index) => {
      if (element.trim() != 0) {
        if (element.includes('::')) {
          grupo[index] = element.split('::');
        } else {
          grupo[index] = element;
          console.log(grupo[index]);
        }
      }
    });

    elements = document.querySelectorAll(`#${idUnico} .carousel-item`);

    j$(`#${idUnico} .carousel`).carousel({
      pause: true,
      interval: false,
    });

    j$(`#${idUnico} .carousel`).on('touchstart', function (event) {
      var xClick = event.originalEvent.touches[0].pageX;
      j$(this).one('touchmove', function (event) {
        var xMove = event.originalEvent.touches[0].pageX;
        if (Math.floor(xClick - xMove) > 5) {
          j$(this).carousel('next');
        } else if (Math.floor(xClick - xMove) < -5) {
          j$(this).carousel('prev');
        }
      });
      j$(`#${idUnico} .carousel`).on('touchend', function () {
        j$(this).off('touchmove');
      });
    });
    check_all_images_complete(() => {
      let text_items = j$(`#${idUnico} .carousel-item`);
      let height = set_same_height_collection(text_items);
      text_items.css('height', `${height + 40}px`);
      root.style.setProperty('--slide-height', `${height + 40}px`);
    });
  });

  afterUpdate(() => {});
</script>

<section class="container" id={idUnico} bind:this={root}>
  <div class="row">
    <div class="col-md-10 mx-auto">
      <!-- <p class="comando desktop">
        {@html comandoFraseDesk}
      </p>
      <p class="comando mobile">
        {@html comandoFraseMob}
      </p> -->
      <div id="{idUnico}-div" class="carousel slide">
        <ol class="carousel-indicators">
          <li data-target="#{idUnico}-div" data-slide-to="0" class="active" data-interval="false" />
          {#each grupo as g, i}
            {#if i !== 0}
              <li data-target="#{idUnico}-div" data-slide-to={`${i}`} />
            {/if}
          {/each}
        </ol>
        <div class="carousel-inner">
          {#each grupo as g, index}
            <ContainerCarousel active={index == 0 ? 'active' : ''}>
              <!-- <h5>
                {@html grupo[index][0]}
              </h5> -->
              <p>
                {@html g}
              </p>
            </ContainerCarousel>
          {/each}
        </div>
        <a class="carousel-control-prev" href="#{idUnico}-div" role="button" data-slide="prev">
          <span class="carousel-control-prev-icon carousel-btn" aria-hidden="true">
            <i>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="46"
                height="75"
                viewBox="0 0 46 75"
                fill="none"
              >
                <defs>
                  <linearGradient
                    id="paint0_linear_618_609"
                    x1="23"
                    y1="-9.81706e-07"
                    x2="23"
                    y2="74.2118"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="var(--MARROM)" />
                    <stop offset="1" stop-color="var(--VERDE_CLARO)" />
                  </linearGradient>
                </defs>
                <path
                  d="M4.73586 73.5207L37.7122 45.264C37.7511 45.2292 37.7705 45.177 37.8093 45.1422L45.1848 38.8262C46.2717 37.8866 46.2717 36.3207 45.1848 35.3811L37.7899 29.0477C37.7316 28.9954 37.682 28.9348 37.6226 28.8839L4.73587 0.704023C2.95021 -0.827128 3.8011e-06 0.303835 3.70218e-06 2.51356L3.13983e-06 15.076C3.10945e-06 15.7545 0.31055 16.4157 0.87342 16.8855L5.29874 20.6786L21.7954 34.8077C23.1934 36.0051 23.1934 38.1674 21.7954 39.3648L5.29874 53.4939L0.873418 57.287C0.310548 57.7568 1.19964e-06 58.418 1.16926e-06 59.0965L6.06908e-07 71.6589C5.06433e-07 73.9035 2.95021 75.0344 4.73586 73.5207Z"
                  fill="url(#paint0_linear_618_609)"
                />
              </svg>
            </i>
          </span>
          <span class="sr-only">Previous</span>
        </a>
        <a class="carousel-control-next" href="#{idUnico}-div" role="button" data-slide="next">
          <span class="carousel-control-next-icon carousel-btn" aria-hidden="true">
            <i>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="46"
                height="75"
                viewBox="0 0 46 75"
                fill="none"
              >
                <path
                  d="M4.73586 73.5207L37.7122 45.264C37.7511 45.2292 37.7705 45.177 37.8093 45.1422L45.1848 38.8262C46.2717 37.8866 46.2717 36.3207 45.1848 35.3811L37.7899 29.0477C37.7316 28.9954 37.682 28.9348 37.6226 28.8839L4.73587 0.704023C2.95021 -0.827128 3.8011e-06 0.303835 3.70218e-06 2.51356L3.13983e-06 15.076C3.10945e-06 15.7545 0.31055 16.4157 0.87342 16.8855L5.29874 20.6786L21.7954 34.8077C23.1934 36.0051 23.1934 38.1674 21.7954 39.3648L5.29874 53.4939L0.873418 57.287C0.310548 57.7568 1.19964e-06 58.418 1.16926e-06 59.0965L6.06908e-07 71.6589C5.06433e-07 73.9035 2.95021 75.0344 4.73586 73.5207Z"
                  fill="url(#paint0_linear_618_609)"
                />
                <defs>
                  <linearGradient
                    id="paint0_linear_618_609"
                    x1="23"
                    y1="-9.81706e-07"
                    x2="23"
                    y2="74.2118"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#B62CA2" />
                    <stop offset="1" stop-color="#33CFB9" />
                  </linearGradient>
                </defs>
              </svg>
            </i>
          </span>
          <span class="sr-only">Next</span>
        </a>
      </div>
    </div>
  </div>
</section>

<style>
  .carousel {
    padding: 40px 30px;
    background: var(--VERDE_CLARO_20);
    border-radius: 15px;
    border: 2px dashed var(--VERDE_CLARO);
  }

  .carousel-btn {
    /* height: 60px; */
    width: 25px;
    outline: black;
    /* background: var(--COR_MOD_PRI); */
    background-size: 100%, 100%;
    /* border-radius: 50%; */
    background-image: none;
    /* box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.2); */
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  .carousel-btn i svg {
    width: 100%;
  }

  .carousel-control-next-icon i {
    padding-left: 5px;
  }
  .carousel-control-prev-icon i {
    padding-right: 5px;
    transform: scaleX(-1);
  }

  .carousel-inner {
    width: 90%;
    margin-left: auto;
    margin-right: auto;
    /* text-wrap: pretty; */
  }

  .carousel-control-next,
  .carousel-control-prev {
    opacity: unset;
    width: 7%;
    transition: all 100ms ease;
  }

  .carousel-control-next:hover,
  .carousel-control-prev:hover {
    opacity: 1;
  }
  .carousel-control-next:hover .carousel-btn,
  .carousel-control-prev:hover .carousel-btn {
    /* background-color: var(--COR_MOD_SEC); */
  }

  .carousel-indicators {
    margin-top: 20px;
    margin-bottom: 15px !important;
    margin-left: auto;
    margin-right: auto;
  }

  .carousel-indicators li {
    all: unset;
    cursor: pointer;
    background: #4ecfc0;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    margin: 0 10px;
    transition: all 150ms ease;
  }

  .carousel-indicators li.active {
    background: var(--MARROM);
  }

  .carousel-inner {
    max-height: 100%;
    text-align: left;
  }

  .carousel-inner :global(p) {
    color: var(--COR_FONTE);
    text-align: left;
    font-weight: 600;
  }

  .carousel-inner :global(h5) {
    color: var(--MARROM);
    font-size: 20px;
    font-family: var(--FONT_INTER);
    min-height: 2em;
    /* padding: 0 5% 0 0; */
    text-align: center;
  }

  .carousel-inner :global(b) {
    color: var(--MARROM);
  }

  :global(.slide-comando) {
    font-family: var(--FONT_LORA);
    text-align: center;
  }

  :global(.carousel-item:nth-child(1) p) {
    font-weight: 400;
    padding-top: calc(var(--slide-height) / 2 - 1.7rem);
    text-align: center;
  }

  @media (max-width: 767px) {
    .carousel {
      padding: 20px 15px 20px 15px;
    }
    .carousel-control-prev,
    .carousel-control-next {
      display: none;
    }
    .carousel-inner {
      width: 95%;
    }
    :global(.carousel-item:nth-child(1) p) {
      font-weight: 400;
      padding-top: unset;
    }
  }

  @media (max-width: 767px) {
    .carousel-indicators li {
      margin: 0 5px;
    }
    .carousel-inner :global(h5) {
      min-height: 4em;
      font-size: 20px;
    }
  }
</style>
